import { useEffect, useState } from "react";

import { getImageObjectSafe } from "@/utils/images";

export const useImageLoader = (url: string) => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!url) return;

    const load = async () => {
      setIsLoading(true);
      const img = await getImageObjectSafe(url);
      setImage(img);
      setIsLoading(false);
    };

    load();
  }, [url]);

  return { image, isLoading };
};
